import { TreeNode } from 'primereact/treenode';

export const removeNodeByKey = (nodes: TreeNode[], key: string): TreeNode[] => {
  return nodes.reduce<TreeNode[]>((newNodes, node) => {
    if (node.key === key) {
      return newNodes;
    } else if (node.children) {
      return [
        ...newNodes,
        { ...node, children: removeNodeByKey(node.children, key) }
      ];
    } else {
      return [...newNodes, node];
    }
  }, []);
};
